/** A headline KPI cell — a number is often the right "chart". Value is
 *  pre-formatted by the caller; text wears ink tokens, never a series colour. */
export function StatTile({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div className="rounded-lg border border-edge bg-bone-surface p-4">
      <div className="text-[10px] font-bold uppercase tracking-[0.02em] text-ink-muted">
        {label}
      </div>
      <div className="mt-1 text-[22px] font-bold leading-tight tabular-nums text-ink">{value}</div>
      {sub && <div className="mt-0.5 text-[12px] text-ink-muted">{sub}</div>}
    </div>
  );
}
